
export const templateStyles = theme => ({

  headerContainer: {
    paddingTop: '4vh',
    display: 'flex',
    justifyContent: 'space-between',
    paddingRight: '2vw',
    paddingBottom: '6vh'
  },
  header: {
    fontSize: '28px',
    fontWeight: 300,
    color: theme.palette.coolGray,
    paddingLeft: '1.5vw',
  },
  addTemplate: {
    margin: '0vh 1.5vw',
    color: theme.palette.white,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
    width: '9vw',
    cursor: 'pointer',
    '&:hover': {
      '& $iconContainer': {
        '& $editIcon': {
          display: 'initial'
        },
        '& $tickIcon': {
          display: 'none'
        }
      }

    }

  },
  
  tickIcon:{
    display: 'initial'
  },
  editIcon:{
    display: 'none'
  },
  imgContainer: {
    width: '130px',
    height: '163px',
    backgroundColor: theme.palette.white,
    borderRadius: '8px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  },
  templatesContainer: {
    display: 'flex'
  },
  loaderDiv: {
    backgroundColor: theme.palette.dark,
    height: '100%',
  },
  img: {
    backgroundColor: theme.palette.tempBlue,
    width: '130px',
    color: theme.palette.white,
    display: 'flex',
    maxHeight: '163px',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
    cursor: 'pointer',
    borderRadius: '8px'
  },
  templateName: {
    color: theme.palette.white,
    fontSize: '13px',
    height: '21px',
    overflow: 'hidden',
    marginTop: '2vh',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  textFieldInput: {
    padding: '14px 20px',
    fontSize: '15px',
    height: '50px',
    boxSizing: 'border-box'
  },
  backdrop: {
    backdropFilter: 'blur(10px)'
  },
  dialog: {
    minWidth: '23vw',
    backgroundColor: 'transparent',
    width: '55vw',
    maxHeight: '100vh', 
    boxShadow: 'none'
  },
  svg: {
    display: 'block',
    margin: 'auto',
    marginBottom: '5vh',
    marginTop: '1vh',
  },
  button: {
    backgroundColor: theme.palette.blue,
    color: theme.palette.white,
    textTransform: 'unset',
    height: '48px',
    borderRadius: '6px',
    marginTop: '20px',
    fontSize: '16px'
  },
  icons: {
    marginLeft: '1vw',
    marginRight: '1vw',
    marginTop: '1vh',
    marginBottom: '1vh',
  },
  loading: {
    top: '40%',
    right: '45%',
    position: 'fixed'
  },
  deleteIcon: {
    cursor: 'pointer'
  },
  draft: {
    backgroundColor: theme.palette.blue,
    color: theme.palette.white,
    fontSize: '12px',

    width: '42px',
    textAlign: 'center',
    borderRadius: '4px',
    padding: '2px'
  },
  iconContainer: {
    justifyContent: 'space-between',
    display: 'flex',
    marginTop: '-3.5vh',
    padding: '0vw 6px',
  },
  mappingContainer: {
    width: '100%',
    height: '100%',
    backgroundColor: theme.palette.dark
  },
  docHeader: {
    color: theme.palette.white,
    fontSize: '22px',
    padding: '0vh 2vw',
    paddingTop: '2vh',

  },
  tempName: {
    color: theme.palette.white,
    fontSize: '22px',
    padding: '0vh 2vw',
    paddingTop: '5vh',

  },
  listItem: {
    display: 'flex',
    justifyContent: 'space-between',
    cursor: 'pointer',
    margin: '1vw'
  },
  tableData: {
    cursor: 'pointer',
    fontSize: '13px',
    padding: '0vh 0vw',
    paddingLeft: '0px',
    color: theme.palette.white,
    borderColor: 'rgba(149,168,210, 0.12)'
  },
  indexData: {
    cursor: 'pointer',
    fontSize: '13px',
    padding: '0vh 0vw',
    paddingLeft: '0px',
    color: theme.palette.white,
    borderColor: 'rgba(149,168,210, 0.12)'

  },
  table: {
    maxWidth: '95vw',
    backgroundColor: theme.palette.dark,
    marginLeft: '3vw',
    marginTop: '3vh'
  },
  tableHeader: {
    color: theme.palette.steelGray,
    fontSize: '13px',
    paddingLeft: '0vw',
    fontWeight: 500,
    paddingRight: '0vw',
    borderColor: 'rgba(149,168,210, 0.12)',

  },
  saveContainer: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: theme.palette.dark
  },
  button: {
    backgroundColor: theme.palette.dullGray,
    color: theme.palette.white,
    textTransform: 'unset',
    height: '48px',
    borderRadius: '6px',
    marginTop: '40px',
    marginRight: '1vw',
    marginBottom: '3vh'
  },
  menuIcon: {
    marginRight: '10px'
  },
  selectContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    height: '90%',
    backgroundColor: theme.palette.dark,
    color: 'white',
    textAlign: 'center'
  },
  radioContainer: {
    flexDirection: 'row',
    color: theme.palette.white,
    fontSize: '15px',
    justifyContent: 'center',
    margin: '1vw'
  },
  radio: {
    color: theme.palette.white,
    fontSize: '20px'
  },
  activeRadio: {
    color: theme.palette.blue,
    fontSize: '20px'
  },
  checkbox: {
    marginLeft: '2vw',
    borderColor: 'rgba(149,168,210, 0.12)',
    color: `${theme.palette.battleShipGray} !important`,
  }
})